import Box from '@liquidweb-dev/undercurrent/Box';
import Card from '@liquidweb-dev/undercurrent/Card';
import CardContent from '@liquidweb-dev/undercurrent/CardContent';
import Link from '@liquidweb-dev/undercurrent/Link';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import { LucideSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';
import Stack from '@liquidweb-dev/undercurrent/Stack';

export interface HelpDocCardDataProps {
	title: string;
	description: string;
	link: string;
	icon?: React.ComponentType<LucideSvgProps>;
}

const HelpDocCard: React.FC<HelpDocCardDataProps> = ({
	title,
	description,
	link,
	icon: Icon,
}) => {
	return (
		<Link
			href={link}
			target="_blank"
			rel="noreferrer"
			sx={{
				textDecoration: 'none',
			}}
		>
			<Card
				key={title}
				sx={{
					padding: 100,
					':hover': { boxShadow: ({ shadows }) => shadows[3] },
				}}
			>
				<CardContent
					sx={{
						display: 'flex',
						gap: { xs: 100, sm: 400 },
						justifyContent: 'space-between',
						alignItems: 'flex-start',
						alignSelf: 'stretch',
					}}
				>
					<Stack
						sx={{
							gap: 100,
						}}
					>
						<Typography variant="title-xs">{title}</Typography>
						<Typography
							variant="body-sm"
							sx={{
								color: (theme) => theme.vars.palette.uc.text.main,
							}}
						>
							{description}
						</Typography>
					</Stack>
					<Box>
						{Icon && (
							<Icon
								sx={({ vars, size }) => ({
									color: vars.palette.uc.highlight.icon.main,
									width: size.sm,
									height: size.sm,
								})}
							/>
						)}
					</Box>
				</CardContent>
			</Card>
		</Link>
	);
};

export default HelpDocCard;
